module.exports = __webpack_public_path__ + "img/tamtech_icon.cdf04aa7.png";